import { render } from "./TextCorrection.vue?vue&type=template&id=b35e6e56&scoped=true"
import script from "./TextCorrection.vue?vue&type=script&lang=js"
export * from "./TextCorrection.vue?vue&type=script&lang=js"

import "./TextCorrection.vue?vue&type=style&index=0&id=b35e6e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35e6e56"]])

export default __exports__